import React, { useEffect, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllProjects } from "../../../../store/slices/projectsSlice";
import { fetchLeads } from "../../../../store/slices/leadsSlice";
import { isProjectLinkedToLostLead } from "../../../../utils/syncLeadProjectBucketStatus";
import {
  setApprovedOpProjectsState,
  setAssignedOpProjectsState,
  setCompleteOpProjectsState,
  setFilterRequestProjectsState,
  setOngoingOpProjectsState,
  setSelectedTabProjectApproved,
  setSelectedTabProjectAssign,
  setSelectedTabProjectComplete,
  setSelectedTabProjectOngoing,
  setSelectedTabProjectRequest,
  setSelectedTabState,
} from "../../../../store/slices/OperationSlices/operationStateSlice";
import { setActiveBucketName, clearActiveBucketName } from "../../../../store/slices/Sidebar/ProcessGuideSlice";
import {
  setToolGuideBucket,
  setToolGuideRole,
  clearToolGuidePath,
} from "../../../../store/slices/Sidebar/ToolGuideSlice";
import { MANAGER_BUCKET_KEYS } from "../../../../features/toolGuide/toolGuideConfig";
// import { useLoggedUser } from "../../../../utils/useLoggedUser";
// import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";

const OpProjects = () => {
  const dispatch = useDispatch();
  const { projects } = useSelector((state) => state.projects);
  const { leads } = useSelector((state) => state.leads);
  // const loggedUser = useLoggedUser();

  useEffect(() => {
    dispatch(fetchAllProjects());
    dispatch(fetchLeads());
  }, [dispatch]);

  const LoggedUser = localStorage.getItem("email");
  const [selectedTab, setSelectedTab] = useState("");
  const [projectsRequest, setProjectsRequest] = useState([]);
  const [filteredProjectsRequest, setFilteredProjectsRequests] = useState([]);
  const [approvedProjectsManager, setApprovedProjectsManager] = useState([]);
  const [assignedOpProjects, setAssignedOpProjects] = useState([]);
  const [ongoingOpProjects, setOngoingOpProjects] = useState([]);
  const [completeOpProjects, setCompleteOpProjects] = useState([]);

  const selectedTabprojectrequest = useSelector(
    (state) => state.operationState.selectedTabprojectrequest
  );

  const selectedTabprojectapproved = useSelector(
    (state) => state.operationState.selectedTabprojectapproved
  ); const selectedTabprojectassign = useSelector(
    (state) => state.operationState.selectedTabprojectassign
  ); const selectedTabprojectongoing = useSelector(
    (state) => state.operationState.selectedTabprojectongoing
  ); const selectedTabprojectcomplete = useSelector(
    (state) => state.operationState.selectedTabprojectcomplete
  );
  useEffect(() => {
    const filteredProjects = projects.filter(
      // const filteredProjects = projects.filter(
      (project) =>
        project.ProjectManagerStatus === "project requested" &&
        Array.isArray(project.Assignedperson) &&
        project.Assignedperson.some(
          (person) => person.email === LoggedUser && (person?.manageraction !== "cancelled" || person?.operationstatus !== "project not-approved")
        ) &&
        !isProjectLinkedToLostLead(project, leads)
    );
    console.log("gdfgdfg filteredProjects" , filteredProjects)
    setProjectsRequest(filteredProjects);
  }, [projects, LoggedUser, leads]);


  useEffect(() => {
    if (!projectsRequest) return;

    const allProjectArrays = [
      approvedProjectsManager,
      assignedOpProjects,
      ongoingOpProjects,
      completeOpProjects,
    ];

    const updatedProjects = projectsRequest.filter((requestProject) => {
      const isMatched = allProjectArrays.some((projectArray) =>
        projectArray?.some(
          (project) => {
            if (project.quotationId != null && requestProject.quotationId != null) {
              return String(project.quotationId) === String(requestProject.quotationId);
            }
            return project.ProjectName === requestProject.ProjectName &&
              project.TypeService === requestProject.TypeService;
          }
        )
      );
      return !isMatched;
    });

    setFilteredProjectsRequests(updatedProjects);
  }, [
    projectsRequest,
    approvedProjectsManager,
    assignedOpProjects,
    ongoingOpProjects,
    completeOpProjects,
  ]);

  useEffect(() => {
    if (!Array.isArray(projects) || !LoggedUser) return;

    const loggedEmail = LoggedUser.toLowerCase();
    const getQuotationIdKey = (proj) => {
      const qid = proj?.quotationId ?? proj?.quotationID ?? proj?.quotationid;
      if (qid != null && String(qid).trim() !== "") {
        return String(qid).trim();
      }
      return null;
    };

    const completedQuotationIds = new Set();
    completeOpProjects.forEach((proj) => {
      const qid = getQuotationIdKey(proj);
      if (qid) completedQuotationIds.add(qid);
    });
    projects.forEach((proj) => {
      const qid = getQuotationIdKey(proj);
      if (!qid) return;
      const userAssignment = proj.Assignedperson?.find(
        (person) => person.email?.toLowerCase() === loggedEmail
      );
      if (userAssignment?.operationstatus === "project complete") {
        completedQuotationIds.add(qid);
      }
    });

    // Exclude from Project Approved when any service row has moved past approved
    // (same rule as SalesProjects — a lead belongs in one bucket only).
    const progressedStatuses = new Set([
      "project assigned",
      "project ongoing",
      "project complete",
    ]);
    const progressedQuotationIds = new Set();
    const progressedProjectKeys = new Set();

    projects.forEach((proj) => {
      const userAssignment = proj.Assignedperson?.find(
        (person) => person.email?.toLowerCase() === loggedEmail
      );
      if (!userAssignment) return;

      const hasProgressed =
        progressedStatuses.has(userAssignment.operationstatus) ||
        progressedStatuses.has(userAssignment.managerstatus);
      if (!hasProgressed) return;

      const qid = getQuotationIdKey(proj);
      if (qid) {
        progressedQuotationIds.add(qid);
        return;
      }

      const projectKey = String(proj.ProjectName || "").trim();
      if (projectKey) progressedProjectKeys.add(projectKey);
    });

    const approvedForUser = projects.filter((proj) => {
      if (isProjectLinkedToLostLead(proj, leads)) return false;

      const quotationId = getQuotationIdKey(proj);
      if (quotationId && completedQuotationIds.has(quotationId)) {
        return false;
      }
      if (quotationId && progressedQuotationIds.has(quotationId)) {
        return false;
      }

      const projectNameKey = String(proj.ProjectName || "").trim();
      if (!quotationId && projectNameKey && progressedProjectKeys.has(projectNameKey)) {
        return false;
      }

      const userAssignment = proj.Assignedperson?.find(
        (person) => person.email?.toLowerCase() === loggedEmail
      );
      if (!userAssignment) return false;
      if (userAssignment.operationstatus === "project complete") {
        return false;
      }
      if (userAssignment.operationstatus) {
        return userAssignment.operationstatus === "project approved";
      }
      return userAssignment.managerstatus === "project approved";
    });

    // One entry per quotation (same project can have multiple TypeService rows).
    const seenKeys = new Set();
    const dedupedApproved = approvedForUser.filter((proj) => {
      const key =
        getQuotationIdKey(proj) ||
        String(proj.ProjectName || "").trim() ||
        String(proj._id || "");
      if (!key || seenKeys.has(key)) return false;
      seenKeys.add(key);
      return true;
    });

    setApprovedProjectsManager(dedupedApproved);
  }, [projects, LoggedUser, completeOpProjects, leads]);


  useEffect(() => {
    const filtered = projects.filter(
      (proj) =>
        Array.isArray(proj.Assignedperson) &&
        proj.Assignedperson.some(
          (person) => person.operationstatus === "project assigned"
        ) &&
        !isProjectLinkedToLostLead(proj, leads)
    );
    const managerProjects = filtered.filter((proj) =>
      proj.Assignedperson?.some(
        (person) => person.email?.toLowerCase() === LoggedUser.toLowerCase()
      )
    );
    setAssignedOpProjects(managerProjects);
  }, [projects, LoggedUser, leads]);



  useEffect(() => {
    const filtered = projects.filter(
      (proj) =>
        Array.isArray(proj.Assignedperson) &&
        proj.Assignedperson.some(
          (person) => person.operationstatus === "project ongoing"
        ) &&
        !isProjectLinkedToLostLead(proj, leads)
    );
    const managerProjects = filtered.filter((proj) =>
      proj.Assignedperson?.some(
        (person) => person.email?.toLowerCase() === LoggedUser.toLowerCase()
      )
    );
    setOngoingOpProjects(managerProjects);
  }, [projects, LoggedUser, leads]);

  useEffect(() => {
    const filtered = projects.filter(
      (proj) =>
        Array.isArray(proj.Assignedperson) &&
        proj.Assignedperson.some(
          (person) => person.operationstatus === "project complete"
        ) &&
        !isProjectLinkedToLostLead(proj, leads)
    );
    const managerProjects = filtered.filter((proj) =>
      proj.Assignedperson?.some(
        (person) => person.email?.toLowerCase() === LoggedUser.toLowerCase()
      )
    );
    setCompleteOpProjects(managerProjects);
  }, [projects, LoggedUser, leads]);

  useEffect(() => {
    if (selectedTab) {
      dispatch(setSelectedTabState(selectedTab));
    }
    if (filteredProjectsRequest.length > 0) {
      dispatch(setFilterRequestProjectsState(filteredProjectsRequest));
    }
    dispatch(setApprovedOpProjectsState(approvedProjectsManager));
    if (assignedOpProjects.length > 0) {
      dispatch(setAssignedOpProjectsState(assignedOpProjects));
    }
    if (ongoingOpProjects.length > 0) {
      dispatch(setOngoingOpProjectsState(ongoingOpProjects));
    }
    if (completeOpProjects.length > 0) {
      dispatch(setCompleteOpProjectsState(completeOpProjects));
    }
  }, [
    selectedTab,
    filteredProjectsRequest,
    approvedProjectsManager,
    assignedOpProjects,
    ongoingOpProjects,
    completeOpProjects,
    dispatch,
  ]);

  // Clear bucket name when all buckets are closed
  useEffect(() => {
    if (!selectedTabprojectrequest && !selectedTabprojectapproved && !selectedTabprojectassign && !selectedTabprojectongoing && !selectedTabprojectcomplete) {
      dispatch(clearActiveBucketName());
      dispatch(clearToolGuidePath());
    }
  }, [selectedTabprojectrequest, selectedTabprojectapproved, selectedTabprojectassign, selectedTabprojectongoing, selectedTabprojectcomplete, dispatch]);

  const syncOpsToolGuideBucket = (bucketName, { force = false } = {}) => {
    const isAnyBucketOpen =
      selectedTabprojectrequest ||
      selectedTabprojectapproved ||
      selectedTabprojectassign ||
      selectedTabprojectongoing ||
      selectedTabprojectcomplete;
    if (!force && isAnyBucketOpen) return;

    dispatch(setToolGuideRole("L4_OPS"));
    dispatch(
      setToolGuideBucket({
        bucketName,
        roleKey: "L4_OPS",
        openPanel: force,
      })
    );
  };

  const handleprojectRequest = (projecttype) => {
    setSelectedTab("projectRequested");
    const isOpening = !selectedTabprojectrequest;
    dispatch(setSelectedTabProjectRequest(isOpening));
    dispatch(setSelectedTabProjectApproved(false));
    dispatch(setSelectedTabProjectAssign(false));
    dispatch(setSelectedTabProjectOngoing(false));
    dispatch(setSelectedTabProjectComplete(false));

    if (projecttype === "projectRequest") {
      dispatch(fetchAllProjects());
    }
    
    if (isOpening) {
      dispatch(setActiveBucketName("Project Requests Outstanding"));
      syncOpsToolGuideBucket(MANAGER_BUCKET_KEYS.PROJECT_REQUESTS, { force: true });
    } else {
      dispatch(clearActiveBucketName());
    }
  };
  const handleprojectApproved = () => {
    const isOpening = !selectedTabprojectapproved;
    dispatch(setSelectedTabProjectApproved(isOpening));
    dispatch(setSelectedTabProjectRequest(false));
    dispatch(setSelectedTabProjectAssign(false));
    dispatch(setSelectedTabProjectOngoing(false));
    dispatch(setSelectedTabProjectComplete(false));

    setSelectedTab("projectApproved");
    dispatch(fetchAllProjects());
    
    if (isOpening) {
      dispatch(setActiveBucketName("Project Approved"));
      syncOpsToolGuideBucket(MANAGER_BUCKET_KEYS.PROJECT_APPROVED, { force: true });
    } else {
      dispatch(clearActiveBucketName());
    }
  };

  const handleprojectAssign = () => {
    const isOpening = !selectedTabprojectassign;
    dispatch(setSelectedTabProjectAssign(isOpening));
    dispatch(setSelectedTabProjectRequest(false));
    dispatch(setSelectedTabProjectApproved(false));
    dispatch(setSelectedTabProjectOngoing(false));
    dispatch(setSelectedTabProjectComplete(false));

    setSelectedTab("projectAssigned");
    dispatch(fetchAllProjects());
    
    if (isOpening) {
      dispatch(setActiveBucketName("Project Assigned"));
      syncOpsToolGuideBucket(MANAGER_BUCKET_KEYS.PROJECT_ASSIGNED, { force: true });
    } else {
      dispatch(clearActiveBucketName());
    }
  };

  const handleprojectOngoing = () => {
    const isOpening = !selectedTabprojectongoing;
    dispatch(setSelectedTabProjectOngoing(isOpening));
    dispatch(setSelectedTabProjectRequest(false));
    dispatch(setSelectedTabProjectApproved(false));
    dispatch(setSelectedTabProjectAssign(false));
    dispatch(setSelectedTabProjectComplete(false));

    setSelectedTab("projectOngoing");
    dispatch(fetchAllProjects());
    
    if (isOpening) {
      dispatch(setActiveBucketName("Project Ongoing"));
      syncOpsToolGuideBucket(MANAGER_BUCKET_KEYS.PROJECT_ONGOING, { force: true });
    } else {
      dispatch(clearActiveBucketName());
    }
  };

  const handleprojectCompleted = () => {
    const isOpening = !selectedTabprojectcomplete;
    dispatch(setSelectedTabProjectComplete(isOpening));
    dispatch(setSelectedTabProjectRequest(false));
    dispatch(setSelectedTabProjectApproved(false));
    dispatch(setSelectedTabProjectAssign(false));
    dispatch(setSelectedTabProjectOngoing(false));

    setSelectedTab("projectCompleted");
    dispatch(fetchAllProjects());
    
    if (isOpening) {
      dispatch(setActiveBucketName("Project Completed"));
      syncOpsToolGuideBucket(MANAGER_BUCKET_KEYS.PROJECT_COMPLETED, { force: true });
    } else {
      dispatch(clearActiveBucketName());
    }
  };
  const [unreadcount, setunreadcount] = useState([]);
  const [unreadcountapproved, setunreadcountapproved] = useState([]);
  const [unreadcountAssign, setunreadcountAssign] = useState([]);
  const [unreadcountongoing, setunreadcountongoing] = useState([]);
  const [unreadcountcomplete, setunreadcountcomplete] = useState([]);

  useEffect(() => {
    const loggedInUserEmail = localStorage.getItem("email"); // Replace with actual logged-in email

    const filteredLeads = filteredProjectsRequest.filter(project => {
      // Check if Assignedperson array exists and has items
      if (!project.Assignedperson || !Array.isArray(project.Assignedperson)) {
        return false;
      }

      // Find if the logged-in user exists in Assignedperson with isRead: false
      const userAssignment = project.Assignedperson.find(person =>
        person.email === loggedInUserEmail && person.isRead === false
      );

      return userAssignment !== undefined;
    });
    setunreadcount(filteredLeads)
  }, [filteredProjectsRequest]);

  useEffect(() => {
    const loggedInUserEmail = localStorage.getItem("email"); // Replace with actual logged-in email

    const filteredLeads = assignedOpProjects.filter(project => {
      // Check if Assignedperson array exists and has items
      if (!project.Assignedperson || !Array.isArray(project.Assignedperson)) {
        return false;
      }

      // Find if the logged-in user exists in Assignedperson with isRead: false
      const userAssignment = project.Assignedperson.find(person =>
        person.email === loggedInUserEmail && person.isRead === false
      );

      return userAssignment !== undefined;
    });
    setunreadcountAssign(filteredLeads)
  }, [assignedOpProjects]);

  useEffect(() => {
    const loggedInUserEmail = localStorage.getItem("email"); // Replace with actual logged-in email

    const filteredLeads = ongoingOpProjects.filter(project => {
      // Check if Assignedperson array exists and has items
      if (!project.Assignedperson || !Array.isArray(project.Assignedperson)) {
        return false;
      }

      // Find if the logged-in user exists in Assignedperson with isRead: false
      const userAssignment = project.Assignedperson.find(person =>
        person.email === loggedInUserEmail && person.isRead === false
      );

      return userAssignment !== undefined;
    });
    setunreadcountongoing(filteredLeads)
  }, [ongoingOpProjects]);

  useEffect(() => {
    const loggedInUserEmail = localStorage.getItem("email"); // Replace with actual logged-in email

    const filteredLeads = completeOpProjects.filter(project => {
      // Check if Assignedperson array exists and has items
      if (!project.Assignedperson || !Array.isArray(project.Assignedperson)) {
        return false;
      }

      // Find if the logged-in user exists in Assignedperson with isRead: false
      const userAssignment = project.Assignedperson.find(person =>
        person.email === loggedInUserEmail && person.isRead === false
      );

      return userAssignment !== undefined;
    });
    setunreadcountcomplete(filteredLeads)
  }, [completeOpProjects]);

  useEffect(() => {
    const loggedInUserEmail = localStorage.getItem("email"); // Replace with actual logged-in email

    const filteredLeads = approvedProjectsManager.filter(project => {
      // Check if Assignedperson array exists and has items
      if (!project.Assignedperson || !Array.isArray(project.Assignedperson)) {
        return false;
      }

      // Find if the logged-in user exists in Assignedperson with isRead: false
      const userAssignment = project.Assignedperson.find(person =>
        person.email === loggedInUserEmail && person.isRead === false
      );

      return userAssignment !== undefined;
    });
    setunreadcountapproved(filteredLeads)
  }, [approvedProjectsManager]);

  return (
    <div id="my-requests-section" className="rounded-md bg-white min-h-[22rem] h-auto relative py-3 pl-2 pr-2">
      <div className="bg-[#e8e8e8] border border-gray-400 text-center py-2 rounded-t-lg font-semibold">
        My Requests
      </div>
      <div className="flex justify-center items-center align-middle w-full p-2">
        <div
          className="flex gap-1 h-[240px] lg:h-[270px] xl:h-[275px] td:h-[360px]  cp:h-[480px] w-[20%] items-center"
        >
          <div className="w-[20%] flex justify-center">
            <p className="-rotate-90 text-black text-md font-semibold whitespace-nowrap">
              Project Requests
            </p>
          </div>
          <div
            onClick={() => handleprojectRequest("projectRequest")}
            className={`relative flex items-center justify-center w-[80%] h-full rounded-2xl border-2 cursor-pointer ${selectedTabprojectrequest
              ? "bg-blue-600 border-[#3a1e0a] shadow-lg"
              : "bg-[#4e95d9] border-[#5A3D2B]"
              }`}
            style={{ borderColor: "#5A3D2B" }}
          >
            {unreadcount.length > 0 && (
              <div className="absolute top-3 flex justify-center align-middle items-center">
                {/* <NotificationsActiveIcon
                  className="text-black w-6 h-6"
                /> */}
                <span

                  className=" opacity-90 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full"
                >
                  {unreadcount.length}
                </span>
              </div>
            )}

            <span className={`text-white ${unreadcount.length > 0 ? "text-2xl font-semibold" : "text-lg"}  font-semibold`}>
              {filteredProjectsRequest.length}
            </span>
            {selectedTabprojectrequest && (
              <ExpandMoreIcon className="absolute bottom-1 text-white cursor-pointer" />
            )}
          </div>
        </div>

        <div
          className="flex gap-1 h-[240px] lg:h-[270px] xl:h-[275px] td:h-[360px]  cp:h-[480px] w-[20%] items-center"
        >
          <div className="w-[20%] flex justify-center">
            <p className="-rotate-90 text-black text-md font-semibold whitespace-nowrap">
              Project Approved
            </p>
          </div>

          <div
            onClick={handleprojectApproved}
            className={`relative flex items-center justify-center w-[80%] h-full rounded-2xl border-2 cursor-pointer ${selectedTabprojectapproved
              ? "bg-yellow-600 border-[#3a1e0a] shadow-lg"
              : " bg-[#ffc000] border-[#5A3D2B]"
              }`}
            style={{ borderColor: "#5A3D2B" }}
          >
            {unreadcountapproved.length > 0 && (
              <div className="absolute top-3 flex justify-center align-middle items-center">
                {/* <NotificationsActiveIcon
                  className="text-black w-6 h-6"
                /> */}
                <span

                  className=" opacity-90 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full"
                >
                  {unreadcountapproved.length}
                </span>
              </div>
            )}
            <span className={`text-white ${unreadcountapproved.length > 0 ? "text-2xl font-semibold" : "text-lg"}`}>{approvedProjectsManager?.length}</span>
            {selectedTabprojectapproved && (
              <ExpandMoreIcon className="absolute bottom-1 text-white cursor-pointer" />
            )}
          </div>
        </div>

        <div
          className="flex gap-1 h-[240px] lg:h-[270px] xl:h-[275px] td:h-[360px]  cp:h-[480px] w-[20%] items-center"
        >
          <div className="w-[20%] flex justify-center">
            <p className="-rotate-90 text-black text-md font-semibold whitespace-nowrap">
              Project Assigned
            </p>
          </div>

          <div
            onClick={handleprojectAssign}
            className={`relative flex items-center justify-center w-[80%] h-full rounded-2xl border-2 cursor-pointer ${selectedTabprojectassign
              ? "bg-yellow-800 border-[#3a1e0a] shadow-lg"
              : "bg-[#cfb053] border-[#5A3D2B]"
              }`}
            style={{ borderColor: "#5A3D2B" }}
          >
            {unreadcountAssign.length > 0 && (
              <div className="absolute top-3 flex justify-center align-middle items-center">
                {/* <NotificationsActiveIcon
                  className="text-black w-6 h-6"
                /> */}
                <span

                  className=" opacity-90 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full"
                >
                  {unreadcountAssign.length}
                </span>
              </div>
            )}
            <span className={`text-white ${unreadcountAssign.length > 0 ? " text-2xl font-semibold" : "text-lg"} `}>
              {assignedOpProjects.length}
            </span>
            {selectedTabprojectassign && (
              <ExpandMoreIcon className="absolute bottom-1 text-white cursor-pointer" />
            )}
          </div>
        </div>
        <div
          className="flex gap-1 h-[240px] lg:h-[270px] xl:h-[275px] td:h-[360px]  cp:h-[480px] w-[20%] items-center"
        >
          <div className="w-[20%] flex justify-center">
            <p className="-rotate-90 text-black text-md font-semibold whitespace-nowrap">
              Project Ongoing
            </p>
          </div>

          <div
            onClick={handleprojectOngoing}
            className={`relative flex items-center justify-center w-[80%] h-full rounded-2xl border-2 cursor-pointer ${selectedTabprojectongoing
              ? "bg-[#D27D2D] border-[#3a1e0a] shadow-lg"
              : "bg-yellow-700 border-[#5A3D2B]"
              }`}
            style={{ borderColor: "#5A3D2B" }}
          >

            {unreadcountongoing.length > 0 && (
              <div className="absolute top-3 flex justify-center align-middle items-center">
                {/* <NotificationsActiveIcon
                  className="text-black w-6 h-6"
                /> */}
                <span

                  className=" opacity-90 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full"
                >
                  {unreadcountongoing.length}
                </span>
              </div>
            )}
            <span className={`text-white ${unreadcountongoing.length > 0 ? " text-2xl font-semibold" : "text-lg"}`}>
              {ongoingOpProjects.length}
            </span>
            {selectedTabprojectongoing && (
              <ExpandMoreIcon className="absolute bottom-1 text-white cursor-pointer" />
            )}
          </div>
        </div>
        <div
          className="flex h-[240px] lg:h-[270px] xl:h-[275px] td:h-[360px]  cp:h-[480px] w-[20%] items-center"
        >
          <div className="w-[20%] flex justify-center">
            <p className="-rotate-90 text-black text-md font-semibold whitespace-nowrap">
              Project Completed
            </p>
          </div>

          <div
            onClick={handleprojectCompleted}
            className={`relative flex items-center justify-center w-[80%] h-full rounded-2xl border-2 cursor-pointer ${selectedTabprojectcomplete
              ? "bg-green-600 border-[#3a1e0a] shadow-lg"
              : "bg-[#47d45a] border-[#5A3D2B]"
              }`}
            style={{ borderColor: "#5A3D2B" }}
          >
            {unreadcountcomplete.length > 0 && (
              <div className="absolute top-3 flex justify-center align-middle items-center">
                {/* <NotificationsActiveIcon
                  className="text-black w-6 h-6"
                /> */}
                <span

                  className=" opacity-90 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full"
                >
                  {unreadcountcomplete.length}
                </span>
              </div>
            )}
            <span className={`text-white ${unreadcountcomplete.length > 0 ? " text-2xl font-semibold" : "text-lg"}`}>
              {completeOpProjects.length}
            </span>
            {selectedTabprojectcomplete && (
              <ExpandMoreIcon className="absolute bottom-1 text-white cursor-pointer" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OpProjects;
